export const TRANSACTION_STATUS_STARTED = 'started';
export const TRANSACTION_STATUS_CANCELLED = 'cancelled';
export const TRANSACTION_STATUS_FAILED = 'failed';
export const TRANSACTION_STATUS_SUCCESS = 'success';
